import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { faqs } from "../mock";

const FAQ = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="py-20 lg:py-28 bg-white">
      <div className="max-w-4xl mx-auto px-5 sm:px-8">
        <div className="reveal text-center max-w-2xl mx-auto">
          <span className="text-[13px] font-bold tracking-[0.22em] text-blue-600 uppercase">
            FAQ
          </span>
          <h2 className="font-display mt-3 text-slate-900 text-[30px] sm:text-[44px] tracking-tight leading-[1.05]" style={{ fontWeight: 900 }}>
            Häufig gestellte Fragen
          </h2>
          <p className="mt-4 text-[16px] sm:text-[17px] text-slate-600">
            Sie haben eine andere Frage? Rufen Sie uns an – wir helfen gern weiter.
          </p>
        </div>

        <div className="mt-12 space-y-3">
          {faqs.map((item, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                className="reveal rounded-2xl border border-slate-200 bg-white overflow-hidden transition-colors hover:border-blue-200"
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 text-left px-6 py-5"
                >
                  <span className="text-[16px] sm:text-[17px] font-semibold text-slate-900">
                    {item.q}
                  </span>
                  <span
                    className={`flex items-center justify-center w-8 h-8 rounded-full shrink-0 transition-colors ${
                      isOpen ? "bg-blue-600 text-white" : "bg-blue-50 text-blue-600"
                    }`}
                  >
                    {isOpen ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ease-in-out ${
                    isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-6 pb-5 text-[15px] leading-relaxed text-slate-600">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
